export default __webpack_public_path__ + "./images/dk.1160c8e7.png";